import { Component, AfterViewInit, OnDestroy, Renderer2, Inject } from '@angular/core';
import { LocalStorageService } from 'library';
import { LocalStorageKey } from '../../../enums';
import { environment } from '../../../../environments/environment';
import { DOCUMENT } from '@angular/common';

// Declaración de variables globales del script OneMarketer
declare global {
  interface Window {
    URLBASE?: string;
    openlivechat?: () => void;
    closelivechat?: () => void;
  }
}

@Component({
  selector: 'app-one-marketer-chat',
  template: '',
})
export class OneMarketerChatComponent implements AfterViewInit, OnDestroy {
  private scriptElement: HTMLScriptElement | null = null;
  private static isScriptLoaded = false; // Control singleton del script

  constructor(
    private localStorageService: LocalStorageService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngAfterViewInit(): void {
    this.loadChatScript();
  }

  ngOnDestroy(): void {
    this.hideChat(); // Solo ocultar, no eliminar
  }

  private buildChatUrl(): string | null {
    const data = this.localStorageService.get(LocalStorageKey.data);
    const email = data?.user?.email ?? '';
    const url = environment.oneMarketerLiveChatUrl?.trim().replace('{email}', email);
    return url || null;
  }

  private loadChatScript(): void {
    // Verificar si el script ya fue cargado en memoria global
    if (OneMarketerChatComponent.isScriptLoaded || window.URLBASE) {
      console.log('OneMarketer script ya está cargado, reutilizando...');
      this.showChat();
      return;
    }

    const chatUrl = this.buildChatUrl();
    if (!chatUrl) {
      return;
    }

    // Verificar si ya existe el script en el DOM
    const existingScript = this.document.querySelector(`script[src*="process.js"]`);
    if (existingScript) {
      console.log('Script OneMarketer encontrado en DOM, marcando como cargado...');
      OneMarketerChatComponent.isScriptLoaded = true;
      this.showChat();
      return;
    }

    // Cargar script por primera vez
    console.log('Cargando OneMarketer script por primera vez...');
    const scriptEl = this.renderer.createElement('script') as HTMLScriptElement;
    this.scriptElement = scriptEl;
    this.renderer.setAttribute(scriptEl, 'src', chatUrl);
    this.renderer.setAttribute(scriptEl, 'type', 'text/javascript');

    // Marcar como cargado cuando termine
    scriptEl.onload = () => {
      OneMarketerChatComponent.isScriptLoaded = true;
      console.log('OneMarketer script cargado exitosamente');
    };

    this.renderer.appendChild(this.document.body, scriptEl);
  }

  private showChat(): void {
    // Mostrar elementos del chat si ya existen
    const foo = this.document.getElementById('foo');
    const btnopen = this.document.getElementById('btnopen');

    if (btnopen) {
      btnopen.style.visibility = 'initial';
      console.log('OneMarketer chat button mostrado');
    }
  }

  private hideChat(): void {
    // Solo ocultar, NO eliminar
    console.log('Ocultando OneMarketer chat');

    const foo = this.document.getElementById('foo');
    const btnopen = this.document.getElementById('btnopen');

    if (foo) {
      foo.style.visibility = 'hidden';
    }
    if (btnopen) {
      btnopen.style.visibility = 'hidden';
    }

    // Cerrar chat si está abierto usando la función global
    if (window.closelivechat) {
      window.closelivechat();
    }
  }
}
